
    import EnderecoIndex from   "./_Index.vue"  
    import { Options, Vue  } from "vue-class-component";   
      
    @Options({
        name: "Cursos",
        components: { EnderecoIndex },  
    }) 
    export default class Cursos extends Vue {
         
    }
